<script lang="ts">
  import { AppState } from '../../etc/stores';
  const { secondary } = $AppState.theme.colors;
  const { firstStopColor, secondary: illustrationSecondary } =
    $AppState.theme.colors.illustration;
</script>

<svg
  width="88"
  height="88"
  viewBox="0 0 88 88"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="44" cy="44" r="44" fill="url(#paint0_linear_4416:120362)" />
  <g filter="url(#filter0_ii_4416:120362)">
    <path
      d="M28.3388 33.49C25.923 30.6716 23.3059 31.2611 22.2994 31.9801C20.1855 33.49 20.7895 36.0064 21.2928 36.5097L37.9013 53.1183C38.7066 54.7288 37.5658 54.7959 36.8948 54.6281L27.8355 46.5756C26.225 44.5625 24.1448 45.4012 23.3059 46.0722C22.098 46.8775 22.1316 48.7564 22.2994 49.5952C22.2994 49.5952 44.5153 70.7441 48.2188 72.2254C51.9222 73.7068 55.5165 72.7466 55.5165 72.7466C59.1401 71.9413 63.0658 68.7202 64.5757 67.2104C69.0046 62.7814 70.0759 57.5402 70.1119 54.6281C70.1478 51.7161 68.602 39.0262 68.602 39.0262C68.1994 35.4025 70.7829 31.4768 72.125 29.967C72.125 28.3564 69.4408 27.9538 68.0987 27.9538C62.8645 27.9538 61.2204 33.6577 61.0526 36.5097C61.0526 39.7308 59.375 40.2005 58.5362 40.0328C57.3283 40.0328 56.0198 39.3617 55.5165 39.0262L40.4178 19.3979C39.4112 18.3914 37.398 17.3846 35.8882 18.3913C33.875 19.3979 33.875 21.9143 34.3783 22.4177L46.4572 39.0262C46.8599 40.2341 45.954 40.2006 45.4507 40.0328L29.8487 21.9144C28.2382 20.3039 26.1383 21.259 25.3191 21.9144C23.3059 23.5249 24.1448 25.6052 24.8158 26.444L41.4244 45.569C41.827 46.7769 40.9211 46.7433 40.4178 46.5756L28.3388 33.49Z"
      fill={secondary}
    />
  </g>
  <path
    d="M28.0794 33.7124L28.0795 33.7123C25.7849 31.0352 23.3681 31.6364 22.4979 32.258C21.5378 32.9438 21.201 33.8478 21.1556 34.6419C21.1327 35.0423 21.1845 35.413 21.2688 35.7081C21.3566 36.0153 21.4682 36.2022 21.5343 36.2682L38.1428 52.8768C38.1688 52.9027 38.1904 52.9327 38.2068 52.9655C38.4196 53.3912 38.5252 53.7549 38.5196 54.0634C38.5136 54.3902 38.3815 54.6481 38.1538 54.8153C37.9432 54.97 37.686 55.0214 37.4626 55.0307C37.2343 55.0402 37.004 55.0075 36.8119 54.9595C36.7585 54.9461 36.709 54.92 36.6679 54.8834L27.6086 46.8308C27.5942 46.818 27.5809 46.804 27.5689 46.7889C26.8331 45.8693 26.0167 45.622 25.2987 45.6584C24.5592 45.696 23.896 46.0375 23.5193 46.3389C23.5116 46.3451 23.5036 46.3509 23.4954 46.3564C22.9996 46.6869 22.7361 47.2532 22.6229 47.8817C22.5197 48.4543 22.5504 49.0349 22.6153 49.4243L22.7848 49.5854C22.9483 49.7405 23.1886 49.9683 23.4958 50.2587C24.1102 50.8396 24.9921 51.6712 26.062 52.6737C28.2019 54.6788 31.0933 57.3675 34.1001 60.1022C37.1074 62.8373 40.2278 65.6164 42.8264 67.8032C44.1259 68.8969 45.292 69.8398 46.2464 70.5543C47.2123 71.2773 47.9305 71.7423 48.3456 71.9083C50.1395 72.6259 51.9126 72.7539 53.2426 72.7003C53.9066 72.6735 54.457 72.6016 54.84 72.5367C55.0313 72.5043 55.1806 72.4737 55.281 72.4515C55.3311 72.4404 55.3691 72.4314 55.3939 72.4253L55.4213 72.4184L55.4274 72.4169L55.4283 72.4166L55.4285 72.4166C55.4284 72.4166 55.4283 72.4166 55.5165 72.7466L28.0794 33.7124ZM28.0794 33.7124L28.0879 33.7217M28.0794 33.7124L28.0879 33.7217M28.0879 33.7217L40.1668 46.8072C40.2059 46.8496 40.2551 46.8813 40.3098 46.8996C40.4589 46.9493 40.6404 46.9902 40.826 47C41.0077 47.0095 41.2225 46.9908 41.4156 46.8926C41.624 46.7865 41.7825 46.5993 41.8412 46.333C41.896 46.0844 41.8588 45.7923 41.7483 45.461C41.7341 45.4184 41.7117 45.379 41.6822 45.3451L25.0783 26.2255C24.778 25.8478 24.4393 25.1873 24.4019 24.4513C24.3655 23.7333 24.6128 22.9168 25.5324 22.1811C25.9044 21.8835 26.5789 21.5118 27.3359 21.4027C28.0751 21.2962 28.8847 21.4389 29.5984 22.1471L45.1919 40.2556C45.2321 40.3024 45.2842 40.3373 45.3427 40.3568C45.4918 40.4065 45.6733 40.4474 45.8589 40.4572C46.0406 40.4668 46.2554 40.448 46.4485 40.3498C46.6569 40.2438 46.8154 40.0565 46.8741 39.7902C46.9289 39.5416 46.8917 39.2495 46.7812 38.9182C46.7702 38.885 46.754 38.8537 46.7334 38.8254L34.6545 22.2168C34.644 22.2024 34.6324 22.1888 34.6198 22.1762C34.5763 22.1327 34.4943 21.9761 34.4578 21.6764C34.4235 21.3953 34.4365 21.0421 34.5223 20.67C34.6937 19.9274 35.1454 19.1446 36.0409 18.6968C36.0536 18.6905 36.0658 18.6834 36.0776 18.6755C36.7202 18.2471 37.4856 18.2336 38.2413 18.4661C38.9912 18.6969 39.692 19.1603 40.1609 19.6241L55.2458 39.2344C55.2685 39.264 55.296 39.2896 55.327 39.3103C55.5995 39.492 56.0747 39.7551 56.6387 39.9738C57.1916 40.1881 57.852 40.3683 58.5034 40.3742C59.015 40.4659 59.7424 40.3626 60.3445 39.7894C60.9591 39.2042 61.3924 38.1787 61.3942 36.5199C61.4772 35.1335 61.9201 33.0585 62.9674 31.34C64.01 29.6292 65.6321 28.2953 68.0987 28.2953C68.7458 28.2953 69.71 28.3935 70.4995 28.6778C71.2558 28.95 71.7146 29.3358 71.7763 29.8467C71.0905 30.6408 70.144 31.9769 69.4002 33.5585C68.6236 35.2099 68.0514 37.1639 68.2625 39.0639L68.263 39.0675M28.0879 33.7217L68.263 39.0675M68.263 39.0675L68.602 39.0262L68.263 39.0675Z"
    stroke="#3D3D3D"
    stroke-opacity="0.03"
    stroke-width="0.683036"
    stroke-linejoin="round"
    style="mix-blend-mode:multiply"
  />
  <g opacity="0.4" filter="url(#filter1_f_4416:120362)">
    <path
      d="M60.8824 42.2225C58.064 41.4173 58.0305 43.5646 58.366 44.739C56.8561 56.8179 60.8824 57.3212 62.3923 56.8179C63.9022 56.3146 64.4055 51.785 65.9153 47.7587C67.4252 43.7324 64.4055 43.2291 60.8824 42.2225Z"
      fill={illustrationSecondary}
    />
  </g>
  <g opacity="0.4" filter="url(#filter2_f_4416:120362)">
    <path
      d="M42.3137 60.5613C41.3027 63.3126 43.4417 63.5045 44.6376 63.2565C56.5723 65.6534 57.3712 61.6752 56.9807 60.1323C56.5902 58.5894 52.11 57.7533 48.2061 55.9505C44.3021 54.1477 43.5774 57.1221 42.3137 60.5613Z"
      fill={illustrationSecondary}
    />
  </g>
  <path
    d="M19.7338 51.8949C19.614 51.6441 19.3135 51.5379 19.0627 51.6577C18.8119 51.7775 18.7057 52.0779 18.8255 52.3288L19.7338 51.8949ZM28.0804 62.1062C28.3189 62.2489 28.628 62.1713 28.7707 61.9327C28.9134 61.6942 28.8357 61.3852 28.5972 61.2425L28.0804 62.1062ZM15.1936 53.8872C15.0622 53.6422 14.7571 53.5501 14.5122 53.6815C14.2672 53.8128 14.1751 54.1179 14.3064 54.3628L15.1936 53.8872ZM26.1405 66.1686C26.3989 66.2709 26.6913 66.1443 26.7936 65.8859C26.8959 65.6274 26.7693 65.335 26.5109 65.2327L26.1405 66.1686ZM46.2654 19.0027C46.0471 18.8307 45.7306 18.8682 45.5586 19.0866C45.3866 19.3049 45.4242 19.6214 45.6425 19.7934L46.2654 19.0027ZM53.0354 30.1526C53.1379 30.411 53.4304 30.5374 53.6888 30.435C53.9472 30.3325 54.0736 30.04 53.9712 29.7816L53.0354 30.1526ZM49.3044 15.4956C49.0949 15.313 48.777 15.3348 48.5943 15.5443C48.4117 15.7538 48.4334 16.0717 48.643 16.2544L49.3044 15.4956ZM57.2992 29.3388C57.3791 29.6051 57.6596 29.7561 57.9259 29.6763C58.1921 29.5964 58.3432 29.3158 58.2633 29.0496L57.2992 29.3388ZM18.8255 52.3288C19.977 54.7397 21.0985 56.4802 22.5427 57.9764C23.9834 59.469 25.7241 60.6965 28.0804 62.1062L28.5972 61.2425C26.2686 59.8492 24.6163 58.6754 23.267 57.2774C21.9212 55.8831 20.8556 54.2438 19.7338 51.8949L18.8255 52.3288ZM14.3064 54.3628C17.4379 60.2031 20.9007 64.095 26.1405 66.1686L26.5109 65.2327C21.577 63.2801 18.2648 59.6151 15.1936 53.8872L14.3064 54.3628ZM45.6425 19.7934C47.5812 21.3207 48.924 22.6527 50.0311 24.2187C51.141 25.7885 52.0295 27.615 53.0354 30.1526L53.9712 29.7816C52.9535 27.2144 52.0304 25.3028 50.8531 23.6376C49.673 21.9685 48.2529 20.5684 46.2654 19.0027L45.6425 19.7934ZM48.643 16.2544C50.9158 18.2357 52.566 19.8244 53.9049 21.7504C55.241 23.6723 56.2842 25.9555 57.2992 29.3388L58.2633 29.0496C57.2292 25.6026 56.1474 23.2126 54.7314 21.1758C53.3181 19.1429 51.5891 17.4873 49.3044 15.4956L48.643 16.2544Z"
    fill="#3D3D3D"
  />
  <g filter="url(#filter3_f_4416:120362)">
    <path
      d="M50.6094 41.8303C47.8773 43.1963 43.0942 50.4693 43.0942 50.4693C42.0014 52.655 43.7773 53.8844 45.1433 54.226C46.5094 54.5675 55.3889 54.5675 55.3889 54.5675C55.3889 54.5675 53.6794 48.3191 55.3889 46.27C57.0983 44.2209 58.4643 41.8304 58.4643 41.8304C58.4643 38.825 53.3416 40.4643 50.6094 41.8303Z"
      fill="#3D3D3D"
      fill-opacity="0.05"
    />
  </g>
  <defs>
    <filter
      id="filter0_ii_4416:120362"
      x="19.8021"
      y="16.9678"
      width="53.3295"
      height="57.0914"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="-1.00658" dy="-4.02632" />
      <feGaussianBlur stdDeviation="0.503289" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.00392157 0 0 0 0 0.164706 0 0 0 0 0.352941 0 0 0 0.12 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect1_innerShadow_4416:120362"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="1.00658" dy="1.00658" />
      <feGaussianBlur stdDeviation="0.503289" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.00392157 0 0 0 0 0.164706 0 0 0 0 0.352941 0 0 0 0.07 0"
      />
      <feBlend
        mode="normal"
        in2="effect1_innerShadow_4416:120362"
        result="effect2_innerShadow_4416:120362"
      />
    </filter>
    <filter
      id="filter1_f_4416:120362"
      x="54.6177"
      y="38.631"
      width="15.1114"
      height="21.7253"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feGaussianBlur
        stdDeviation="1.70759"
        result="effect1_foregroundBlur_4416:120362"
      />
    </filter>
    <filter
      id="filter2_f_4416:120362"
      x="38.6349"
      y="51.9916"
      width="21.8335"
      height="15.4302"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feGaussianBlur
        stdDeviation="1.70759"
        result="effect1_foregroundBlur_4416:120362"
      />
    </filter>
    <filter
      id="filter3_f_4416:120362"
      x="39.3393"
      y="36.7218"
      width="22.5402"
      height="21.2609"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feGaussianBlur
        stdDeviation="1.70759"
        result="effect1_foregroundBlur_4416:120362"
      />
    </filter>
    <linearGradient
      id="paint0_linear_4416:120362"
      x1="44"
      y1="0"
      x2="44"
      y2="88"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={firstStopColor} />
      <stop offset="1" stop-color={firstStopColor} stop-opacity="0" />
    </linearGradient>
  </defs>
</svg>
